import React from 'react';

import { GreekIslandsPageDescriptionAndImageItemViewModel } from '@api/v3';
import Typography from '@components/Typography';

import {
  DesktopContainer,
  IslandItems,
  IslandItemsContainer,
  MainContainer,
  TextContainer,
  TextContainerBottomDescription,
} from './styled';
import IslandItem from './Item';

const DesktopGreekIslands = ({
  data,
}: {
  data?: GreekIslandsPageDescriptionAndImageItemViewModel;
}) => {
  return (
    <DesktopContainer>
      <MainContainer>
        <TextContainer>
          <Typography variant='Title3' weight='Black' color='D400'>
            {data?.title}
          </Typography>
        </TextContainer>
        <TextContainer>
          <Typography variant='caption1' weight='Regular' color='D400'>
            {data?.topText}
          </Typography>
        </TextContainer>
        <IslandItemsContainer>
          {data?.greekIslandsPageImageItems?.map((item) => (
            <IslandItems key={item.title}>
              <IslandItem
                title={item.title ?? ''}
                image={{
                  url: item.images[0]?.url ?? '',
                  alt: item.images[0]?.url,
                }}
                url={item?.url ?? ''}
              />
            </IslandItems>
          ))}
        </IslandItemsContainer>
        <TextContainer>
          <TextContainerBottomDescription>
            <Typography variant='caption1' weight='Regular' color='D400'>
              {data?.bottomText}
            </Typography>
          </TextContainerBottomDescription>
        </TextContainer>
      </MainContainer>
    </DesktopContainer>
  );
};
export default DesktopGreekIslands;
